import { isDefined } from "./other/isDefined";

/**
 * This function will display {digits} after the decimal separator
 * @param digits: number of decimal figures
 */
export default (value: number | undefined, digits = 2) =>
  isDefined(value) ? Math.round(value * 10 ** digits) / 10 ** digits : 0;
